import styled from 'particles/themes/styled'

export const SubmissionsWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    padding: ${({ theme }) => theme.spacing[300]};
    @media screen and (max-width: 768px) {
        min-width: 1060px;
    }
    overflow: hidden;
`

export const EmptyStateWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
`
